/**
 * 封面
 */
import React from 'react'
import classNames from 'classnames'
import { MyImage } from '~/components/ui/MyImage'
import { aiCollectionList_aiCollectionQuery_list_edges_node } from '~/graphqls/types'

export interface ICoverDomData
  extends aiCollectionList_aiCollectionQuery_list_edges_node {
  [key: string]: any
}
interface IProps {
  data: ICoverDomData
  height?: number
}
const CoverDom: React.FC<IProps> = ({ data, height = '100%' }) => {
  const coverList = data?.coverAiArtworks || []
  let coverDom = <></>
  switch (coverList.length) {
    case 0:
      coverDom = (
        <>
          {Array(4)
            .fill('')
            .map((_, index) => (
              <div key={index} className="w-[50%] h-[50%] p-[1px]">
                <div className="h-full bg-[rgba(255,255,255,0.04)]"></div>
              </div>
            ))}
        </>
      )
      break
    case 1:
      coverDom = (
        <div className="w-full h-full p-[1px]">
          <MyImage
            tag="v400"
            className="h-full"
            src={coverList[0]?.miniArtWorkUrl}
          />
        </div>
      )
      break
    case 2:
      coverDom = (
        <>
          {coverList.map((item, index) => (
            <div key={index} className="h-[50%] w-full p-[1px]">
              <MyImage
                tag="v400"
                className="h-full"
                src={item?.miniArtWorkUrl}
              />
            </div>
          ))}
        </>
      )
      break
    case 3:
      coverDom = (
        <>
          {coverList.map((item, index) => (
            <div
              key={index}
              className={classNames('p-[1px]', [
                index === 0 ? 'h-[62.3%] w-full' : 'h-[37.7%] w-[50%]',
              ])}
            >
              <MyImage
                tag="v400"
                className="h-full"
                src={item?.miniArtWorkUrl}
              />
            </div>
          ))}
        </>
      )
      break
    case 4:
      coverDom = (
        <>
          {coverList.map((item, index) => (
            <div key={index} className="w-[50%] h-[50%] p-[1px]">
              <MyImage
                tag="v400"
                className="h-full"
                src={item?.miniArtWorkUrl}
              />
            </div>
          ))}
        </>
      )
      break
    case 5:
      coverDom = (
        <>
          {coverList.map((item, index) => (
            <div
              key={index}
              className={classNames('p-[1px]', [
                index < 2 ? 'h-[66%]' : 'h-[34%]',
                index < 2 ? 'w-[50%]' : 'w-[33.3333%]',
              ])}
            >
              <MyImage
                tag="v400"
                className="h-full"
                src={item?.miniArtWorkUrl}
              />
            </div>
          ))}
        </>
      )
      break
    case 6:
      coverDom = (
        <>
          <div className="p-[1px] h-[66%] w-[66.6666%]">
            <MyImage
              tag="v400"
              className="h-full"
              src={coverList[0]?.miniArtWorkUrl}
            />
          </div>
          <div className="p-[1px] h-[66%] w-[33.3333%]">
            <div className="h-[50%]">
              <MyImage
                tag="v400"
                className="h-full"
                src={coverList[1]?.miniArtWorkUrl}
              />
            </div>
            <div className="h-[50%] mt-[1px]">
              <MyImage
                tag="v400"
                className="h-full"
                src={coverList[2]?.miniArtWorkUrl}
              />
            </div>
          </div>
          <div className="p-[1px] h-[34%] w-[33.3333%]">
            <MyImage
              tag="v400"
              className="h-full"
              src={coverList[3]?.miniArtWorkUrl}
            />
          </div>
          <div className="p-[1px] h-[34%] w-[33.3333%]">
            <MyImage
              tag="v400"
              className="h-full"
              src={coverList[4]?.miniArtWorkUrl}
            />
          </div>
          <div className="p-[1px] h-[34%] w-[33.3333%]">
            <MyImage
              tag="v400"
              className="h-full"
              src={coverList[5]?.miniArtWorkUrl}
            />
          </div>
        </>
      )
      break
    case 7:
      coverDom = (
        <>
          {coverList.map((item, index) => (
            <div
              key={index}
              className={classNames('p-[1px]', [
                index < 1 ? 'h-[50%]' : 'h-[25%]',
                index < 1 ? 'w-full' : 'w-[33.3333%]',
              ])}
            >
              <MyImage
                tag="v400"
                className="h-full"
                src={item?.miniArtWorkUrl}
              />
            </div>
          ))}
        </>
      )
      break
    case 8:
      coverDom = (
        <>
          {coverList.map((item, index) => (
            <div
              key={index}
              className={classNames('p-[1px]', [
                index < 2 ? 'h-[50%]' : 'h-[25%]',
                index < 2 ? 'w-[50%]' : 'w-[33.3333%]',
              ])}
            >
              <MyImage
                tag="v400"
                className="h-full"
                src={item?.miniArtWorkUrl}
              />
            </div>
          ))}
        </>
      )
      break
    case 9:
      coverDom = (
        <>
          {coverList.map((item, index) => (
            <div
              key={index}
              className={classNames('p-[1px] w-[33.3333%] h-[33.3333%]')}
            >
              <MyImage
                tag="v400"
                className="h-full"
                src={item?.miniArtWorkUrl}
              />
            </div>
          ))}
        </>
      )
      break
    default:
      break
  }

  return (
    <div
      className="relative rounded-lg flex flex-wrap overflow-hidden mb-2 w-full"
      style={{ height }}
    >
      {coverDom}
    </div>
  )
}
export default CoverDom
